export default [
    {
        path: '/nuestro-trabajo',
        name: 'nuestrotrabajo',
        component: () => import('@/modules/NuestroTrabajo'),
        meta: {
            requiresAuth: false,
            title: 'Nuestro Trabajo | Fundación Rebeca Lan'
        },
    }
];
